@import '../../../globals/main.scss';

pn-proxio-findprice {
  .findprice-form {
    margin: 0em auto 3em auto;

    fieldset {
      border: none;
    }
  }

  .findprice-form-wrapper {
    background-color: $blue25;
    padding: 3.2rem;
  }

  .sizeTable {
    background-color: transparent !important;
    border-style: none !important;
    border: 0 !important;
    position: relative;

    > tr td {
      margin-bottom: 1em;
      text-align: center;
      vertical-align: bottom;
      padding-right: 1em;
      padding-top: 1em;
      position: relative;
      z-index: 1;
    }

    #clouds {
      position: absolute;
      top: 3rem;
      width: 100%;
    }
  }

  .firstCell {
    margin-right: 0;
    margin-left: auto;
  }

  [slot='title'] {
    margin-bottom: 1rem;
  }

  h2 {
    text-align: center;
  }

  .findprice__heading {
    text-align: center;
    line-height: 1.1;
    font-weight: bold;
    color: $black;
    font-size: 3.2rem;
    font-weight: 700;
  }

  .findprice__subheading {
    font-size: 2.4rem;
    margin-bottom: 2.4rem;
  }

  .resultHeading {
    text-align: center;
    font-size: 1.5em;
    line-height: 1.1;
    font-weight: bold;
    margin-bottom: 2em;
  }

  .findprice__clear-all-filters {
    display: flex;
    justify-content: center;
    margin: 2.4rem;
    color: #005d92;

    .findprice__clear-all-filters__btn {
      width: fit-content;
      cursor: pointer;
    }
  }

  .sizecategory {
    margin-top: 1em;
    margin-bottom: 3rem;
    font-size: 0.9em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .weightoption {
    font-size: 0.9em;
    margin: 0 auto;
  }

  .shipmentcountry {
    margin-top: 3rem;
    display: flex;
    flex-direction: column;

    .shipmentcountry-header {
      text-align: center;
      font-size: 2rem;
      font-weight: 700;
      line-height: 2.2rem;
    }

    select {
      color: $blue700;
      font-size: 1.6rem;
      font-weight: 500;
      border-radius: 0.8rem;
      cursor: pointer;
      outline: none;
      position: relative;
      display: -ms-flexbox;
      display: flex;
      padding: 0.6em 1em;
      z-index: 0;
      -webkit-transition: z-index 0s 0.5s;
      transition: z-index 0s 0.5s;
      appearance: none;
      width: 100%;

      @media screen and (min-width: 500px) {
        min-width: 47.3rem;
        width: inherit;
      }
    }

    .shipmentcountry-select-container {
      max-width: inherit;
      position: relative;
      margin-top: 1.2rem;
      width: 100%;

      @media screen and (min-width: 500px) {
        margin: 0 auto;
        margin-top: 1.2rem;
        width: inherit;
      }

      svg {
        position: absolute;
        z-index: 1;
        right: 1rem;
        top: 1.5rem;
        pointer-events: none;

        path {
          fill: $blue700;
        }
      }
    }
  }

  .findprice-form-wrapper .weightoption .weightoption-content {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;

    pn-choice-button {
      width: 7em;
      line-height: 3.3em;
      font-size: 0.9em;
      vertical-align: bottom;
      background: $white;
      border-radius: 1rem;

      > label {
        align-content: center;
        justify-content: center;
        color: $black;
        margin-bottom: 0;
      }

      ::before {
        content: 'Max \a0';
        font-weight: lighter;
        color: $gray700;
      }
    }
  }

  .resultlist {
    max-width: 60em;
    margin: 3.2rem auto 3.2rem auto;
  }

  .servicePoint {
    text-align: center;

    pn-illustration {
      display: block;
      max-width: 5em;
      max-height: 5em;
      margin: 1.5em auto 0 auto;
    }

    h3 {
      margin-top: 0.8em;
      margin-bottom: 0.9em;
    }

    a {
      color: $blue700;
      text-decoration: none;

      &:hover {
        color: $blue900;
        text-decoration: underline;
      }
    }
  }
}
